const priceAttribute = 'data-prices';
const priceSelector = `[${priceAttribute}]`;

export function initPrices() {
  let priceSections = document.querySelectorAll(priceSelector);
  priceSections.forEach((priceSection) => { initPrice(priceSection); });
}

export function initPrice(priceSection) {

  let netValue = priceSection.querySelector('[name$="NetValue"]');
  let taxPercentage = priceSection.querySelector('[name$="TaxPercentage"]');
  let grossValue = priceSection.querySelector('[name$="GrossValue"]');
  let discountPercentage = priceSection.querySelector('[name$="DiscountPercentage"]');
  let netDiscountValue = priceSection.querySelector('[name$="NetDiscountValue"]');
  let netSellValue = priceSection.querySelector('[name$="NetSellValue"]');
  let grossDiscountValue = priceSection.querySelector('[name$="GrossDiscountValue"]');
  let grossSellValue = priceSection.querySelector('[name$="GrossSellValue"]');
  let taxValue = priceSection.querySelector('[name$="TaxValue"]');

  let event = 'change';

  netValue.addEventListener(event, () => updateFromNetValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue));
  taxPercentage.addEventListener(event, () => updateFromTaxPercentage(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue));
  grossValue.addEventListener(event, () => updateFromGrossValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue))
  discountPercentage.addEventListener(event, () => updateFromDiscountPercentage(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue));
  netDiscountValue.addEventListener(event, () => updateFromNetDiscountValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue));
  netSellValue.addEventListener(event, () => updateFromNetSellValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue));
  grossDiscountValue.addEventListener(event, () => updateFromGrossDiscountValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue));
  grossSellValue.addEventListener(event, () => updateFromGrossSellValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue));


  let netPrice = 0;
  let taxPercent = 0;
  let grossPrice = 0;
  let discountPercent = 0;
  let netSellPrice = 0;
  let grossSellPrice = 0;

  let taxPrice = () => grossSellPrice - netSellPrice;
  let grossDiscountPrice = () => grossPrice * discountPercent / 100;
  let netDiscountPrice = () => netPrice * discountPercent / 100;

  function updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	netValue.value = netPrice;
	taxPercentage.value = taxPercent;
	grossValue.value = grossPrice;
	discountPercentage.value = discountPercent;
	netDiscountValue.value = netDiscountPrice();
	netSellValue.value = netSellPrice;
	grossDiscountValue.value = grossDiscountPrice();
	grossSellValue.value = grossSellPrice;
	taxValue.value = taxPrice();
  }
  function updateFromNetValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	netPrice = Number(netValue.value);
	taxPercent = Number(taxPercentage.value);
	if (Number.isNaN(netPrice) || Number.isNaN(taxPercent))
	  return;

	grossPrice = netPrice * (1 + (taxPercent / 100));
	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);
  }
  function updateFromTaxPercentage(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	taxPercent = Number(taxPercentage.value);
	netPrice = Number(netValue.value);
	if (Number.isNaN(netPrice) || Number.isNaN(taxPercent))
	  return;

	grossPrice = netPrice * (1 + (taxPercent / 100));
	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);
  }
  function updateFromGrossValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	taxPercent = Number(taxPercentage.value);
	grossPrice = Number(grossValue.value);
	discountPercent = Number(discountPercentage.value);

	if (Number.isNaN(discountPercent) || Number.isNaN(grossPrice) || Number.isNaN(taxPercent))
	  return;

	netPrice = grossPrice / (1 + (taxPercent / 100));
	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);
  }
  function updateFromDiscountPercentage(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	discountPercent = Number(discountPercentage.value);
	grossPrice = Number(grossValue.value);
	netPrice = Number(netValue.value);
	if (Number.isNaN(discountPercent) || Number.isNaN(grossPrice) || Number.isNaN(netPrice))
	  return;

	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);

  }
  function updateFromNetDiscountValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	let modifiedNetDiscountPrice = Number(netDiscountValue.value);
	grossPrice = Number(grossValue.value);
	netPrice = Number(netValue.value);
	if (Number.isNaN(modifiedNetDiscountPrice) || Number.isNaN(grossPrice) || Number.isNaN(netPrice))
	  return;

	discountPercent = modifiedNetDiscountPrice * 100 / netPrice;
	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);
  }
  function updateFromNetSellValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	netSellPrice = Number(netSellValue.value);
	netPrice = Number(netValue.value);
	grossPrice = Number(grossValue.value);
	if (Number.isNaN(netSellPrice) || Number.isNaN(netPrice) || Number.isNaN(grossPrice))
	  return;

	discountPercent = 100 - (netSellPrice * 100 / netPrice);
	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);
  }
  function updateFromGrossDiscountValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	let modifiedGrossDiscountPrice = Number(grossDiscountValue.value);
	grossPrice = Number(grossValue.value);
	netPrice = Number(netValue.value);
	if (Number.isNaN(modifiedGrossDiscountPrice) || Number.isNaN(grossPrice) || Number.isNaN(netPrice))
	  return;

	discountPercent = modifiedGrossDiscountPrice * 100 / grossPrice;
	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);
  }
  function updateFromGrossSellValue(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue) {
	grossSellPrice = Number(grossSellValue.value);
	netPrice = Number(netValue.value);
	grossPrice = Number(grossValue.value);
	if (Number.isNaN(grossSellPrice) || Number.isNaN(netPrice) || Number.isNaN(grossPrice))
	  return;

	discountPercent = 100 - (grossSellPrice * 100 / grossPrice);
	grossSellPrice = grossPrice - grossDiscountPrice();
	netSellPrice = netPrice - netDiscountPrice();

	updateValues(netValue, taxPercentage, grossValue, discountPercentage, netDiscountValue, netSellValue, grossDiscountValue, grossSellValue, taxValue);
  }

}

document.addEventListener('DOMContentLoaded', initPrices);